import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from '../http.service';

import { Country } from '../../../models/checkout/country';
import { CountryParams } from '../../../models/checkout/countryParams';
import { CountryStatesParams } from '../../../models/checkout/countryStatesParams';
import {HttpConfiguration} from '../../../app.http.config';
import { HttpClient } from '@angular/common/http';



@Injectable()
export class CountryHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/country/', RequestTypes.InternalApi, httpConfig, http);
    }

    public getCountries(countryParams: CountryParams): Observable<any> {
        return this.get(`getCountries?forLegacy=${countryParams.forLegacy}&addressType=${countryParams.addressType}`,
            null).pipe();
    }

    public getStates(countryStatesParams: CountryStatesParams): Observable<any> {
        return this.get(`getStates?forLegacy=${countryStatesParams.forLegacy}&addressType=${countryStatesParams.addressType}&countryId=${countryStatesParams.countryId}`,
            null).pipe();
    }

    public getCountriesStates(): Observable<any> {
        return this.get('getCountriesStates', null).pipe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/country.http.service.ts